<template>
  <div v-if="cluster" class="modal-content-frame modal-content-frame-sensors">
    <div class="zone-go-back" @click="goToStageOne()">
      <IconGoBack />
      Go Back
    </div>

    <div class="zone-header zone-header--sensors">
      <div>
        <label for="chips">Add Zones</label>
        <p>Select one or more zones to add. Greyed out zones are already assigned to clusters.</p>
      </div>
    </div>

    <div class="event-form event-form--row">
      <ul class="event-form--zones-list" v-if="newEvent">
        <ZonePreview
          v-for="(zone, index) in newEvent.zones"
          :key="index"
          v-model:zone="newEvent.zones[index]"
          v-model:checkedZones="cluster.zones"
          :canEdit="false"
          :canRemove="false"
          :showTypes="false"
          :index="index"
          :active="cluster.zones.includes(zone)"
        />
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { EventTypeNew, ClusterType } from '@/types/Event';

import ZonePreview from '@/components/events/ZonePreview.vue';
import IconGoBack from '@/icons/events/IconGoBack.svg?component';

const newEvent = defineModel<EventTypeNew>('newEvent');
const cluster = defineModel<ClusterType>('cluster');

const emit = defineEmits(['changeStage']);

const goToStageOne = () => {
  emit('changeStage');
};
</script>
